"use client";

import { ReactNode } from 'react';
import Providers from './Providers';

export default function ClientProvidersWrapper({ children }: { children: ReactNode }) {
  return <Providers>{children}</Providers>;
}
